/*
 * Accordion
 *
 **/

custom.Accordion = (function () {
  /**
   * Class Name definitions
   */
  const activeClass = 'js-accordion-open';
  const initializedClass = 'js-accordion-initialized';

  const accordionClasses =
    '.js-accordion, .ais-facet-conjunctive, .ais-RefinementList, .ais-range-slider';
  const accordionTitleClasses = '.js-accordion-trigger, .ais-header';
  const accordionContentClasses = '.js-accordion-target, .ais-body';

  const preOpenClass = 'ais-range-slider--header';
  const preOpenToggleableClass = 'js-start-open';
  const contentObserveClassName = 'js-accordion-target-observe';
  const allowOpenAllClass = 'js-accordion-open-all';

  const accordionMinus = '.accordion__title--icon-minus';
  const accordionPlus = '.accordion__title--icon-plus';
  const cartPage = $('.template-cart').length;

  let accordions;
  let accordionTitles;
  let accordionContents;
  let accordionCloseBtn;

  function variablesSet() {
    accordions = $(accordionClasses);
    accordionTitles = $(accordionTitleClasses);
    accordionContents = $(accordionContentClasses);
    accordionCloseBtn = $('.js-accordion-close');
  }

  function setupAccessibility() {
    $.each(accordionTitles, function (index, item) {
      var $this = $(item);

      $this.attr('aria-label', 'Menu');
      $this.attr('aria-expanded', 'false');
      $this.attr('id', 'accordion-item-' + index);
    });

    $.each(accordionContents, function (index, item) {
      var $this = $(item);
      var sibling = $(accordionTitles[index]).attr('id');

      $this.attr('aria-labelledby', sibling);
      $this.attr('aria-hidden', 'true');
    });
  }

  /**
   * openItem
   * Open single accordion item.
   * @function
   * @param {object} item - Accordion item to open.
   */
  function openItem($item = null) {
    if (!$item.hasClass(activeClass)) $item.addClass(activeClass);
    let newHeight = $item.find(accordionContentClasses).prop('scrollHeight');
    $item.find(accordionContentClasses).css('maxHeight', newHeight);
    cartIcons($item);
    //close all other accordions
    if (!cartPage && !$item.closest('.accordion').hasClass(allowOpenAllClass)) {
      closeItem($item.siblings());
    }
    setTimeout(function () {
      if ($item.hasClass(activeClass)) {
        /**
         * Fix height to not be restricted in case external video was lazy-loaded in
         * and accordion is still open, or other content was inserted.
         */
        $item.find(accordionContentClasses).css('maxHeight', 'none');
      }
    }, 1500);
  }

  /**
   * closeItem
   * Close single accordion item.
   * @function
   * @param {object} item - Accordion item to close.
   */
  function closeItem($item = null) {
    if ($item.hasClass(activeClass)) $item.removeClass(activeClass);
    $item.find(accordionContentClasses).css('maxHeight', 0);
    cartIcons($item);
  }
  /**
   * toggleItem
   * Toggle accordion item depending on the state.
   * @function
   * @param {object} event - Click event of trigger button
   */
  function toggleItem(event = null) {
    event.preventDefault();
    const $item = $(event.currentTarget).closest(accordionClasses);

    if (
      $(event.currentTarget).text() == 'View Details' ||
      $(event.currentTarget).text() == 'View Less'
    ) {
      $item.hasClass(activeClass)
        ? $(event.currentTarget).text('View Details')
        : $(event.currentTarget).text('View Less');
    }
    return $item.hasClass(activeClass) ? closeItem($item) : openItem($item);
  }

  function closeAllItems() {
    $.each(accordions, function (index, item) {
      $(item).removeClass(activeClass);
      $(item).find(accordionContentClasses).css('maxHeight', 0);
    });

    $.each(accordionTitles, function (index, item) {
      $(item).attr('aria-expanded', 'false');
    });

    $.each(accordionContents, function (index, item) {
      $(item).attr('aria-hidden', 'true');
    });

    $(accordionMinus).addClass('hidden');
    $(accordionPlus).removeClass('hidden');
  }

  function keepToggleOpen($item) {
    $item.trigger('click');
    openItem($item);
    $item.off('click', toggleItem);
  }

  function setupBindings() {
    variablesSet();
    setupAccessibility();

    //loop through accordion titles
    $.each(accordionTitles, function (index, item) {
      var $item = $(item);

      let accordionItem = $item.closest(accordionClasses);
      if (!accordionItem.hasClass(initializedClass)) {
        //add click handler to the title
        $item.on('click', toggleItem);
        //see if parent has pre open class
        if (accordionItem.hasClass(preOpenToggleableClass)) {
          openItem(accordionItem);
        }
        //see if title has stay open class
        if ($item.hasClass(preOpenClass)) keepToggleOpen(accordionItem);
        //add initialized class
        accordionItem.addClass(initializedClass);
      }
    });
    // bind close button
    if (accordionCloseBtn.length > 0 && !cartPage) {
      accordionCloseBtn.on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        closeAllItems();
      });
    }
  }

  /**
   * resizeObserver
   * Listen to events of accordion contents getting resized.
   * @function
   * @param {func} callback - function or method on contents resize.
   */
  function resizeObserveHandler(callback = () => {}) {
    const contentInners = document.querySelectorAll(
      `.${contentObserveClassName}`,
    );
    if (!contentInners) return;

    var ro = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const $item = $(entry.target).closest(accordionClasses);
        if ($item.hasClass(initializedClass) && $item.hasClass(activeClass))
          openItem($item);
      }
    });

    Array.from(contentInners).forEach((content) => ro.observe(content));
  }

  function cartIcons($item = null) {
    if ($item.hasClass(activeClass)) {
      $item.find(accordionMinus).removeClass('hidden');
      $item.find(accordionPlus).addClass('hidden');
    } else {
      $item.find(accordionMinus).addClass('hidden');
      $item.find(accordionPlus).removeClass('hidden');
    }
  }

  function init() {
    resizeObserveHandler();
    setupBindings();
    $(window).on('load', setupBindings);
  }

  return {
    init,
    openItem,
    closeItem,
    setupBindings,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/accordion.js